exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-table[data-v-15bdcf72] {\n  width: 100%;\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 10px;\n}\n.field-table td[data-v-15bdcf72] {\n  padding: 0 0 10px;\n}", ""]);

// exports
